/** Shared formatting helpers for the Database Explorer blocks. */

// RO-3-02 / RO-4-04: additive subpath, not the bare barrel (see `path-label.ts`).
import { HIRING_DISPLAY_NAME } from "@excellent/core/jtbd-registry";

export function formatBytes(n: number): string {
  if (!Number.isFinite(n) || n < 0) return "—";
  if (n < 1024) return `${n} B`;
  const units = ["KB", "MB", "GB", "TB"];
  let v = n / 1024;
  let i = 0;
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024;
    i++;
  }
  return `${v.toFixed(v < 10 ? 1 : 0)} ${units[i]}`;
}

export function formatCount(n: number): string {
  if (n < 0) return "—";
  return n.toLocaleString();
}

/** Group → display label + ordering for the table inventory. */
export const GROUP_LABELS: Record<string, string> = {
  core: "Core",
  "golden-schema": "Schema",
  crm: "CRM",
  hiring: HIRING_DISPLAY_NAME,
  help: "Help",
  excellent: "Excellent",
  database: "Database",
  system: "System",
  other: "Other",
};

export const GROUP_ORDER = [
  "core",
  "golden-schema",
  "crm",
  "hiring",
  "help",
  "excellent",
  "database",
  "other",
  "system",
];
